import FileDownload from 'js-file-download';
import { Reducer } from 'redux';
import { ICaseAction, ICaseState } from '../../../common/model/CaseModels';

const SEARCH_CASE_REQUEST = 'SEARCH_CASE_REQUEST';
const SEARCH_CASE_SUCCESS = 'SEARCH_CASE_SUCCESS';
const SEARCH_CASE_FAILURE = 'SEARCH_CASE_FAILURE';
const CASE_RESET = 'CASE_RESET';

const LOOKUP_CASE_REQUEST = 'LOOKUP_CASE_REQUEST';
const LOOKUP_CASE_SUCCESS = 'LOOKUP_CASE_SUCCESS';
const LOOKUP_CASE_FAILURE = 'LOOKUP_CASE_FAILURE';

const CASE_TRUSTNESS_REQUEST = 'CASE_TRUSTNESS_REQUEST';
const CASE_TRUSTNESS_SUCCESS = 'CASE_TRUSTNESS_SUCCESS';
const CASE_TRUSTNESS_FAILURE = 'CASE_TRUSTNESS_FAILURE';

const FILE_TRUSTNESS_REQUEST = 'FILE_TRUSTNESS_REQUEST';
const FILE_TRUSTNESS_SUCCESS = 'FILE_TRUSTNESS_SUCCESS';
const FILE_TRUSTNESS_FAILURE = 'FILE_TRUSTNESS_FAILURE';
const COMPLETE_TRUST_EVENT = 'COMPLETE_TRUST_EVENT';

const DOWNLOAD_FILE_REQUEST = 'DOWNLOAD_FILE_REQUEST';
const DOWNLOAD_FILE_SUCCESS = 'DOWNLOAD_FILE_SUCCESS';
const DOWNLOAD_FILE_FAILURE = 'DOWNLOAD_FILE_FAILURE';

export const requestCaseSearch = (fips, caseId) => ({
    type: SEARCH_CASE_REQUEST,
    fips,
    caseId,
});

export const successCaseSearch = (fips, caseId, payload) => ({
    type: SEARCH_CASE_SUCCESS,
    fips,
    caseId,
    payload,
});

export const failedCaseSearch = (fips, caseId, error) => ({
    type: SEARCH_CASE_FAILURE,
    fips,
    caseId,
    error,
});

export const requestLookUp = () => ({
    type: LOOKUP_CASE_REQUEST,
});

export const successLookUp = (payload) => ({
    type: LOOKUP_CASE_SUCCESS,
    payload,
    meta: {
        debounce: {
            time: 1000,
        },
    },
});

export const failedLookUp = (error) => ({
    type: LOOKUP_CASE_FAILURE,
    error,
    meta: {
        debounce: {
            time: 1000,
        },
    },
});

export const requestCaseTrustness = (workspaceId, caseId) => ({
    type: CASE_TRUSTNESS_REQUEST,
    workspaceId,
    caseId,
});

export const successCaseTrustness = (workspaceId, caseId, payload) => ({
    type: CASE_TRUSTNESS_SUCCESS,
    workspaceId,
    caseId,
    payload,
});

export const failedCaseTrustness = (workspaceId, caseId, error) => ({
    type: CASE_TRUSTNESS_FAILURE,
    workspaceId,
    caseId,
    error,
});

export const requestFileTrustness = (fileIds) => ({
    type: FILE_TRUSTNESS_REQUEST,
    fileIds,
});

export const successFileTrustness = (fileIds) => ({
    type: FILE_TRUSTNESS_SUCCESS,
    fileIds,
});

export const failedFileTrustness = (error) => ({
    type: FILE_TRUSTNESS_FAILURE,
    error,
});
export const completeFileTrustEvent = () => ({
    type: COMPLETE_TRUST_EVENT,
});

export const requestFileDownload = (id) => ({
    type: DOWNLOAD_FILE_REQUEST,
    id,
});

export const successFileDownload = (id, name, payload) => {
    FileDownload(payload, name);
    return {
        type: DOWNLOAD_FILE_SUCCESS,
        id,
    };
};

export const failedFileDownload = (id, error) => ({
    type: DOWNLOAD_FILE_FAILURE,
    id,
    error,
});

export const resetCase = () => ({
    type: CASE_RESET,
});

// reducer for shared actions

export const caseReducer: Reducer<ICaseState, ICaseAction> = (
    state: ICaseState = { files: [] },
    action: ICaseAction
) => {
    switch (action.type) {
        case SEARCH_CASE_REQUEST:
            return {
                ...state,
                selectedCaseId: null,
                selectedCaseData: {
                    data: null,
                    searching: true,
                    error: null,
                },
            };

        case SEARCH_CASE_SUCCESS:
            return {
                ...state,
                selectedCaseId: action.caseId,
                selectedCaseData: {
                    data: action.payload,
                    searching: false,
                    error: null,
                },
            };

        case SEARCH_CASE_FAILURE:
            return {
                ...state,
                selectedCaseData: {
                    searching: false,
                    error: action.error,
                },
            };

        case CASE_RESET:
            return {
                ...state,
                selectedCaseData: null,
                selectedCaseId: null,
            };

        case CASE_TRUSTNESS_REQUEST:
            return {
                ...state,
                [action.workspaceId]: {
                    ...state[action.workspaceId],
                    [action.caseId as string]: {
                        ...(state[action.workspaceId] &&
                            state[action.workspaceId][action.caseId]),
                        checkingTrust: true,
                        trustError: null,
                    },
                },
            };

        case CASE_TRUSTNESS_SUCCESS:
            return {
                ...state,
                [action.workspaceId]: {
                    ...state[action.workspaceId],
                    [action.caseId as string]: {
                        ...(state[action.workspaceId] &&
                            state[action.workspaceId][action.caseId]),
                        checkingTrust: false,
                        trust: action.payload,
                    },
                },
            };

        case CASE_TRUSTNESS_FAILURE:
            return {
                ...state,
                [action.workspaceId]: {
                    ...state[action.workspaceId],
                    [action.caseId as string]: {
                        ...(state[action.workspaceId] &&
                            state[action.workspaceId][action.caseId]),
                        checkingTrust: false,
                        trustError: action.error,
                    },
                },
            };

        // case DOWNLOAD_FILE_REQUEST:
        //     return {
        //         ...state,
        //         files: {
        //             [action.id]: {
        //                 downloading: true,
        //                 error: null,
        //             },
        //         },
        //     };
        // case DOWNLOAD_FILE_SUCCESS:
        //     return {
        //         ...state,
        //         files: {
        //             [action.id]: {
        //                 downloading: false,
        //                 error: null,
        //             },
        //         },
        //     };
        //
        // case DOWNLOAD_FILE_FAILURE:
        //     return {
        //         ...state,
        //         files: {
        //             [action.id]: {
        //                 downloading: false,
        //                 error: action.error,
        //             },
        //         },
        //     };
        //
        case FILE_TRUSTNESS_REQUEST:
            const files = {};

            action.fileIds.forEach((id) => {
                files[id] = {
                    checkingTrust: true,
                    trustError: null,
                };
            });
            return {
                ...state,
                fileTrustnessEventLoading: true,
                files: {
                    ...state.files,
                    ...files,
                },
            };

        case FILE_TRUSTNESS_SUCCESS:
            return {
                ...state,
                files: {
                    ...state.files,
                    ...action.fileIds,
                },
            };

        case FILE_TRUSTNESS_FAILURE:
            return {
                ...state,
                fileTrustnessEventLoading: false,
                files: {
                    ...state.files,
                    [action.fileId]: {
                        checkingTrust: false,
                        trustError: action.error,
                    },
                },
            };
        case COMPLETE_TRUST_EVENT:
            Object.keys(state.files).forEach(
                (v) => (state.files[v].checkingTrust = false)
            );
            return {
                ...state,
                fileTrustnessEventLoading: false,
            };
        case LOOKUP_CASE_REQUEST:
            return {
                ...state,
                lookingUp: true,
                lookUpError: null,
            };
        case LOOKUP_CASE_SUCCESS:
            return {
                ...state,
                lookingUp: false,
                lookUpResult: action.payload,
            };
        case LOOKUP_CASE_FAILURE:
            return {
                ...state,
                lookingUp: false,
                lookUpResult: [],
                lookUpError: action.error,
            };

        default:
            return state;
    }
};
